"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { Button } from "@nxt-costco-com/forge-components";
import { COMPARE_PRODUCT_TILE_COMPONENT_NAME } from "../constants.js";
import { getEmptySlotText } from "../lib.js";
import { StyledContainer, StyledImage, StyledImagePlaceholder } from "./styles.js";
const CompareProductTile = ({
  emptySlotTemplateText,
  index,
  noImageUrl,
  onRemove,
  product,
  removeButtonText
}) => {
  const handleRemove = (partNumber) => {
    onRemove(partNumber);
  };
  const emptySlotText = getEmptySlotText(emptySlotTemplateText, index + 1);
  const imageId = `image-${index}`;
  const buttonId = `remove-${index}`;
  return /* @__PURE__ */ jsxs(
    StyledContainer,
    {
      "data-bi-private": product == null ? void 0 : product.isFsaOrChd,
      "data-private": product == null ? void 0 : product.isFsaOrChd,
      "data-testid": COMPARE_PRODUCT_TILE_COMPONENT_NAME,
      children: [
        product && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            StyledImage,
            {
              alt: product.alt || void 0,
              id: imageId,
              loading: "lazy",
              src: product.compareImage || noImageUrl
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              "aria-labelledby": `${buttonId} ${imageId}`,
              id: buttonId,
              onClick: () => handleRemove(product.partNumber),
              sx: { lineHeight: "1.5", whiteSpace: "nowrap" },
              variant: "text-button",
              children: removeButtonText
            }
          )
        ] }),
        !product && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Box, { sx: visuallyHidden, children: emptySlotText }),
          /* @__PURE__ */ jsx(StyledImagePlaceholder, {})
        ] })
      ]
    }
  );
};
CompareProductTile.displayName = COMPARE_PRODUCT_TILE_COMPONENT_NAME;
export {
  CompareProductTile
};
